export function removeDuplicatesByLabel<T extends { label: string }>(
  array: T[]
): T[] {
  const seen = new Set<string>();
  return array.filter((item) => {
    if (seen.has(item.label)) {
      return false;
    }
    seen.add(item.label);
    return true;
  });
}
